var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{attrs:{"button-create-show":true,"link":"/users/create"},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('Table',{attrs:{"columns":_vm.columns,"options":_vm.columnsOptions,"method-fetch-data":_vm.methods.fetchData}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }